import { select } from "redux-saga/effects";
import { stringify as serializeQueryParams } from "query-string";

import { ScreenerStore } from "../model";
import { allFieldConfiguration } from "../../fields";

export function* paramsToQueryStringSerialize() {
	const store: ScreenerStore = yield select();

	const newQueryString: { [key: string]: string } = { };
	for (const fieldConfiguration of allFieldConfiguration) {
		var input = store.filter.inputs[fieldConfiguration.systemName];
		fieldConfiguration.serializeValue(input, newQueryString);
	}

	let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + serializeQueryParams(newQueryString);
	window.history.replaceState({path: newurl}, '', newurl);
}
